<template>
  <div class="flex flex-col items-start gap-1">
    <Draggable v-model="values">
      <MultistringInputField
        v-for="(_value, index) in values"
        :key="index"
        v-model="values[index]"
        :index="index"
        @remove="values.splice(index, 1)"
      />
    </Draggable>

    <Multiline.Add :values="values" @click="values.push('')" />
  </div>
</template>

<script lang="ts" setup>
import isDeepEqual from "fast-deep-equal";
import { ref, watch } from "vue";

import { useSettingControl } from "@/components/Setting/context";
import Draggable from "@/lib/pragmatic-dnd/Draggable.vue";

import MultistringInputField from "./internal/MultistringInputField.vue";
import Multiline from "./Multiline";

const modelValue = defineModel<string[]>({ required: true });
const values = ref<string[]>(modelValue.value.slice() || [""]);

watch(
  values,
  (next) => {
    modelValue.value = next.slice();
  },
  { deep: true }
);

watch(
  modelValue,
  (next) => {
    if (!next || isDeepEqual(next, values.value)) {
      return;
    }

    values.value = next.slice();
  },
  { deep: true }
);

const setting = useSettingControl();
setting?.register({ multiple: true });
</script>
